import {
  Table,
  TableHead,
  TableHeadRow,
  TableHeadCell,
  TableBody,
  Pagination,
  Skeleton,
  EmptyPlaceholder,
  TableCell,
  TableRow,
} from '@client/toolkit';
import { useTranslation } from 'react-i18next';
import { TrailRow } from './trail-row';
import { useState, useCallback, useRef } from 'react';
import { AgreementActivityLogDto, useGetAgreementsByAgreementIdActivityLogsQuery } from '@client/api';
import { useParams } from 'react-router-dom';

function ActivityRowSkeleton() {
  return (
    <TableRow>
      {Array.from(Array(9).keys()).map((idx) => (
        <TableCell key={idx}>
          <Skeleton className="w-full h-full" />
        </TableCell>
      ))}
    </TableRow>
  );
}
export function AuditTable() {
  const { t } = useTranslation('agreements');

  const [page, setPage] = useState(0);
  const { id } = useParams<{ id: string }>();
  const containerRef = useRef<HTMLDivElement>(null);

  const handlePageChange = useCallback((newPage: number) => {
    setPage(newPage);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);
  const { data, isFetching, isLoading } = useGetAgreementsByAgreementIdActivityLogsQuery(
    { agreementId: id ?? '', orderBy: 'logTime', page: page, pageSize: 30 },
    { skip: id == null },
  );

  return (
    <div ref={containerRef}>
      <Table className="overflow-hidden w-full mb-4" size="xs" layout="fixed">
        <TableHead>
          <TableHeadRow>
            <TableHeadCell>{t('auditTrail.time')}</TableHeadCell>
            <TableHeadCell>{t('auditTrail.company')}</TableHeadCell>
            <TableHeadCell>{t('auditTrail.traceId')}</TableHeadCell>
            <TableHeadCell>{t('auditTrail.user')}</TableHeadCell>
            <TableHeadCell>{t('auditTrail.type')}</TableHeadCell>
            <TableHeadCell>{t('auditTrail.summary')}</TableHeadCell>
            <TableHeadCell>{t('auditTrail.changes')}</TableHeadCell>
            <TableHeadCell>{t('auditTrail.erp')}</TableHeadCell>
            <TableHeadCell>{t('auditTrail.result')}</TableHeadCell>
          </TableHeadRow>
        </TableHead>
        {!isLoading && (!data || data.items.length === 0) && (
          <caption className="px-4 py-4 [caption-side:bottom]">
            <EmptyPlaceholder>{t('auditTrail.noActivity')}</EmptyPlaceholder>
          </caption>
        )}
        <TableBody>
          {isFetching
            ? Array.from(Array(3).keys()).map((idx: number) => <ActivityRowSkeleton key={idx} />)
            : data && data.items.map((item: AgreementActivityLogDto) => <TrailRow key={item.id} item={item} />)}
        </TableBody>
      </Table>
      <Pagination totalCount={data?.total ?? 0} currentPage={page} setPage={handlePageChange} pageSize={30} />
    </div>
  );
}
